module.exports = __webpack_public_path__ + "static/img/SC.f9d39e9d.svg";